<nz-modal
    [(nzVisible)]="isVisible"
    [nzOkLoading]="submitLoading"
    [nzMaskClosable]="false"
    (nzOnCancel)="close()"
    (nzOnOk)="onSubmit()"
    nzWidth="1100px"
    nzTitle="Add Task"
    nzOkText="OK"
    nzCancelText="Cancel"
>
    <ng-container *nzModalContent>
        <app-task-create-form
            #taskForm
            [projectId]="projectId"
            [taskId]="taskId"
        ></app-task-create-form>
    </ng-container>
</nz-modal>
